import * as React from 'react';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { RouteProps } from 'react-router';
import { IStore } from 'redux/IStore';
import { getArticleSearchResultsAll, resetSearchData } from 'modules/search/articlesearchresults';
import { IArticleSearchResultsAction, IArticleSearchResultsData } from 'models/search/articlesearchresults';
import { IItemCardList } from 'models/itemcard/itemcardlist';
import * as c from 'models/constants';
import { IUserPreferences } from 'models/user/userpreferences';
import { IInfiniteScrollProps } from 'models/infinitescroll';
import { ItemCardList } from 'components';
import { ErrorPage } from 'containers';
import { getArticleCard } from 'redux/modules/magazine/article/articlecard';
import { IArticleCardAction } from 'models/magazine/article/articlecard';
import { formatInteger, getNextPageCount } from 'helpers/common';
require('./style.scss');

interface IProps {
	articleSearchResultsData?: IArticleSearchResultsData;
	userPreferences?: IUserPreferences;
	route?: RouteProps;
	routeParams?: IArticleSearchResultsRouteParams;
	location?: Location;
	languageKey: number;
	resetSearchData?: () => IArticleSearchResultsAction;
	t?: (key: string) => string;
	getArticleSearchResultsAll?: Redux.ActionCreator<IArticleSearchResultsAction>;
	getArticleCard?: (id: string) => IArticleCardAction;
}

interface IArticleSearchResultsRouteParams {
	keyword?: string;
	id?: string;
}

@connect(
	(state: IStore) => ({
		articleSearchResultsData: state.articleSearchResults,
		userPreferences: state.userPreferences,
		languageKey: state.userLanguage.languageKey,
	}),
	(dispatch) => ({
		getArticleSearchResultsAll: (
			isFirstLoad: boolean,
			keyword: string,
			queryType: string,
			sortOrder: string,
			lanuageKey: number,
			id?: string,
		) => dispatch(getArticleSearchResultsAll(isFirstLoad, keyword, queryType, sortOrder, lanuageKey, id)),
		resetSearchData: () => dispatch(resetSearchData()),
		getArticleCard: (id: string) => dispatch(getArticleCard(id)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class MagazineArticleSearchResults extends React.Component<IProps, any> {
	private sortOrder: string = 'AddedDate DESC';

	constructor(props) {
		super(props);

		this.loadMoreData = this.loadMoreData.bind(this);
		this.getDataByRoutePath = this.getDataByRoutePath.bind(this);
		this.orderArticles = this.orderArticles.bind(this);
	}

	public componentDidMount() {
		if (this.props.location) {
			this.getDataByRoutePath(true);
		}
	}

	public componentDidUpdate(prevProps: IProps) {
		let keyword = this.props.routeParams.keyword;
		if (keyword && keyword.length > 0) {
			keyword = decodeURIComponent(keyword);
		}
		let prevKeyword = prevProps.routeParams.keyword;
		if (prevKeyword && prevKeyword.length > 0) {
			prevKeyword = decodeURIComponent(prevKeyword);
		}
		if (this.props.route && keyword && (prevKeyword !== keyword || prevProps.languageKey !== this.props.languageKey)) {
			const routePath: string = this.props.route.path;
			this.props.getArticleSearchResultsAll(
				true,
				keyword,
				routePath,
				this.sortOrder,
				this.props.languageKey,
				this.props.routeParams.id,
			);
		}
	}

	public componentWillUnmount() {
		this.props.resetSearchData();
	}

	public getDataByRoutePath(isFirstLoad: boolean) {
		const routePath: string = this.props.route.path;
		let keyword = this.props.routeParams.keyword;
		if (keyword && keyword.length > 0) {
			keyword = decodeURIComponent(keyword);
		}
		this.props.getArticleSearchResultsAll(
			isFirstLoad,
			keyword,
			routePath,
			this.sortOrder,
			this.props.languageKey,
			this.props.routeParams.id,
		);
	}

	public loadMoreData() {
		this.getDataByRoutePath(false);
	}

	public orderArticles(e, sortorder: number) {
		const btns = document.getElementsByClassName('orderBtn');
		[].forEach.call(btns, (el) => {
			el.classList.remove('active');
		});
		e.target.classList.add('active');
		const sortOrderOptions = ['AddedDate DESC', 'AddedDate ASC'];
		this.sortOrder = sortOrderOptions[sortorder];

		this.getDataByRoutePath(true);
	}

	public render() {
		if (this.props.articleSearchResultsData.error) {
			return <ErrorPage {...this.props} message={this.props.articleSearchResultsData.message} />;
		}

		const { items, itemsPage, keyword } = this.props.articleSearchResultsData;
		const { t } = this.props;

		if (!itemsPage) {
			return '';
		}

		const nextPageItems = getNextPageCount(itemsPage, items.length);

		const infiniteScrollProps: IInfiniteScrollProps = {
			dataLength: items.length,
			next: this.loadMoreData,
			hasMore: nextPageItems > 0,
			loader: <h4>{t('BSPortal_Common_Loading')} </h4>,
		};

		const listProps: IItemCardList = {
			items,
			itemType: c.NODE_TYPE_MAGAZINE_ARTICLE_ITEM_CARD,
			isInfiniteScroll: true,
			infiniteScrollProps,
			currentUserId: this.props.userPreferences.id,
			currentUserIsAdministrator: this.props.userPreferences.isAdministrator,
			currentUserIsEditor: this.props.userPreferences.isEditor,
			goToCard: (id: string) => this.props.getArticleCard(id),
			nextPageItems,
		};

		return (
			<div className="container magazineArticleSearchResults">
				<div className="row">
					<div className="col-md-12">
						<div className="searchTopTitle">
							{itemsPage?.totalItems > 0 ? (
								<>
									<div className="topText">
										{t('SearchArticles_SearchResultsFor')} "<span>{keyword}</span>"
									</div>
									<div className="searchResults">
										{formatInteger(itemsPage.totalItems)} {t('SearchArticles_Title').toLowerCase()}
									</div>
								</>
							) : (
								<>
									<div className="noResults-wrapper">
										<div className="topText">
											{t('SearchArticles_NoResultsFoundFor')} "<span>{keyword}</span>"
										</div>
										<div className="searchResults">{t('SearchArticles_NoResultsFoundFor_Subtext')}</div>
									</div>
								</>
							)}
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-12">
						<div className="articleCards-wrapper">
							<ItemCardList {...listProps} />
						</div>
					</div>
				</div>
			</div>
		);
	}
}
export { MagazineArticleSearchResults };
